import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  FormControl,
  Dialog,
  Slide,
} from "@material-ui/core";
import React, { useState } from "react";
import FlagIcon from "@material-ui/icons/Flag";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import UploadCMO from "./UploadCMO";
import { convertToLocaleDateTime } from "../../functionalComponents/FormatDateTimeToLocale";
import ChatBox from "../ChatBox";
import useBatchDetails from "./useBatchDetails";
//import useBatchDetails from "./useBatchDetails";
const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
    borderCollapse: "collapse", // Ensures no extra spacing
    "& .MuiTableCell-root": {
      padding: "8px 12px",
      lineHeight: "1.2",
      fontSize: "0.8rem",
    },
  },
  headerCell: {
    fontWeight: 500,
    // width: "10%",
  },
  grayRow: {
    backgroundColor: "#f7f6f6",
  },
  spaceBetween: {
    lineHeight: "2",
  },
  lotNumbers: {
    display: "block",
    lineHeight: "1.5",
  },
  stickyHeaderRow: {
    position: "sticky",
    top: 0,
    zIndex: 1,
  },

  btnDownload: {
    textTransform: "none",
    backgroundColor: "white",
    borderRadius: "50px",
    border: "1px solid black",
    "&:hover": {
      backgroundColor: "white",
    },
  },

  btnSync: {
    background:
      "transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box;",
    color: "white",
    textTransform: "none",
    borderRadius: "2rem",

    padding: "5px 20px",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
    },
  },
  btnSave: {
    marginBottom: "3em",
    textTransform: "none",
    borderRadius: "50px",
    backgroundColor: "#ec6535",
    color: "white",
    "&:hover": {
      backgroundColor: "#ec6535",
    },
  },
  centeredCell: {
    verticalAlign: "middle",
  },

  cellStyle: {
    width: "10%", // Ensures consistent column width across tables
    // margin: 0,
    // padding: 0,
    // outline: "1px solid pink",
  },
  collapsedRow: {
    backgroundColor: "#f7f6f6",
  },
  reasonCode: {
    width: "50%",
    padding: 0,
    margin: 0,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  colorBox: {
    width: 16,
    height: 16,
  },
  bmsColor: {
    backgroundColor: "#BE2BBB",
  },
  cmoColor: {
    backgroundColor: "#1B4489",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(4),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const displayNoDataFound = (
  <Box
    style={{
      display: "flex",
      justifyContent: "center", // Horizontally center the CircularProgress
      alignItems: "center", // Vertically center the CircularProgress
      height: "50px", // Optional: Set a height to vertically center the loader
      border: "2px solid #000",
      // backgroundColor: "#FFF0F0",
      // width: "100%",
      marginTop: "20px",
    }}
  >
    <Typography style={{ textAlign: "center" }}>No Records Found</Typography>
  </Box>
);
export default function BatchTable({
  batchDetails,
  handleSave,
  setRefresh,
  handleReason: handleChange,
  selectedReasons,
  vendorData,
  featuresAccess,
  batchLoading,
  hasChanges,
  filter,
  // apiData
}) {
  const classes = useStyles();
  const { apiData } = useBatchDetails(filter, vendorData);

  // const [selectedReasons, setSelectedReasons] = useState({});
  // const { batchDetails, error, handleSave } = useBatchDetails(
  //   filter,
  //   selectedReasons,
  //   setLoading,
  //   setSaveDialog
  // );
  const [openRows, setOpenRows] = useState({});
  const [uploadDialog, setUploadDialog] = useState(false);

  // const handleChange = (index, event) => {
  //   const { value } = event.target;
  //   setSelectedReasons((prev) => ({ ...prev, [index]: value }));
  // };

  const toggleRow = (materialInfo) => {
    setOpenRows((prev) => ({ ...prev, [materialInfo]: !prev[materialInfo] }));
  };

  const reasonOptions = [
    "Decimal rounding",
    "Wastage, explained and accounted",
    "Material used but not yet updated in SAP",
    "Need more information",
  ];

  const reasonDropDown = (index, value) => (
    <FormControl>
      <Select
        variant="outlined"
        size="small"
        name="reasonForDifference"
        value={selectedReasons[index] || value || ""}
        onChange={(e) => handleChange(index, e)}
        style={{
          height: "30px",
          backgroundColor: "white",
          width: "100px",
        }}
      >
        {reasonOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
  const handleUpload = () => {
    setUploadDialog(true);
  };
  const handleClose = () => {
    setUploadDialog(false);
    setRefresh((prev) => !prev);
  };

  return (
    <Box style={{ marginTop: "1em" }}>
      <Box style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6">
          <span
            style={{
              borderBottom: "4px solid #a9a9a9",
              paddingBottom: "2px",
            }}
          >
            Co
          </span>
          mponent Batch Details
        </Typography>
        <Box style={{ display: "flex", gap: "1em" }}>
          {featuresAccess?.downloadReport && (
            <Button
              variant="contained"
              size="small"
              className={classes.btnDownload}
              style={{ cursor: "not-allowed" }}
              disabled={true}
            >
              Download Report
            </Button>
          )}
          {localStorage.collabType === "CMO" &&
            featuresAccess?.uploadCMOInventory && (
              <Button
                variant="contained"
                size="small"
                className={classes.btnSync}
                onClick={handleUpload}
              >
                Upload CMO Inventory
              </Button>
            )}
        </Box>
        <Dialog
          fullScreen
          open={uploadDialog}
          onClose={() => handleClose()}
          TransitionComponent={Transition}
        >
          <UploadCMO
            handleClose={() => handleClose()}
            vendorData={vendorData}
          />
        </Dialog>
      </Box>
      <TableContainer
        component={Paper}
        style={{ margin: "1em 0", minHeight: "auto", maxHeight: "400px" }}
        className={classes.tableContainer}
      >
        <Table stickyHeader className={classes.table} size="small">
          <TableHead>
            <TableRow
              className={`${classes.grayRow} ${classes.stickyHeaderRow}`}
            >
              <TableCell></TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.cellStyle}`}
              >
                Material Code / Description
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.cellStyle}`}
              >
                Batch Numbers
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.cellStyle}`}
                align="right"
              >
                On-Hand Qty. Available
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.cellStyle}`}
                align="right"
              >
                On-Hand Qty. Difference
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.headerCell} ${classes.cellStyle}`}
              >
                On-Hand Qty. Difference (%)
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.headerCell} ${classes.cellStyle}`}
              >
                Quantity Committed
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.cellStyle}`}
                align="right"
              >
                Qty. Committed Difference
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.headerCell} ${classes.cellStyle}`}
              >
                Qty. Committed Difference (%)
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.cellStyle}`}
              >
                UoM
              </TableCell>
              <TableCell
                className={`${classes.headerCell} ${classes.reasonCode}`}
              >
                Reason For Difference
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {batchDetails?.length === 0 && (
              <TableCell colSpan={11} style={{ padding: 0 }}>
                {displayNoDataFound}
              </TableCell>
            )}
            {batchDetails?.map((item) => (
              <React.Fragment key={item.materialInfo}>
                <TableRow
                  hover
                  onClick={() => toggleRow(item.materialInfo)}
                  style={{ cursor: "pointer" }}
                >
                  <TableCell>
                    <IconButton size="small">
                      {openRows[item.materialInfo] ? (
                        <KeyboardArrowUpIcon />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell className={classes.cellStyle}>
                    {item?.materialInfo || "NA"}
                  </TableCell>
                  <TableCell
                    style={{ padding: "0px" }}
                    className={classes.cellStyle}
                  >
                    {/* EAF7DB,c0d8cd */}
                    <div
                      style={{
                        // backgroundColor: "#cbb1c3",
                        paddingTop: "1.14rem",
                        paddingRight: "12px",
                        paddingLeft: "12px",
                        paddingBottom: "0.5rem",
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: "0.95rem",
                          fontWeight: "410",
                          color: "#BE2BBB"
                          //backgroundColor: "#cbb1c3",
                        }}
                      >
                        {" "}
                        Sponsor {" "}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "0.8rem",
                          color: "#BE2BBB"
                          // whiteSpace:"nowrap"
                        }}
                      >
                        {convertToLocaleDateTime(
                          item?.sponsorLastUpdatedDate
                        ) || "NA"}
                      </Typography>
                    </div>
                    <div
                      style={{
                        // backgroundColor: "#A1AFCC",
                        color: "#1B4489",
                        paddingTop: "0.5rem",
                        paddingBottom: "1.14rem",
                        paddingRight: "12px",
                        paddingLeft: "12px",
                      }}
                    >
                      <Typography
                        style={{ fontSize: "0.95rem", fontWeight: "410", color: "#1B4489" }}
                      >
                        {" "}
                        CMO{" "}
                      </Typography>
                      <Typography style={{ fontSize: "0.8rem" }}>
                        {convertToLocaleDateTime(item?.cmoLatestUpdateDate) ||
                          "NA"}
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell
                    style={{ padding: "0px" }}
                    className={classes.cellStyle}
                    align="right"
                  >
                    <div
                      style={{
                        // backgroundColor: "#cbb1c3",
                        color: "#BE2BBB",
                        paddingTop: "2.5rem",
                        paddingBottom: "2rem",
                        paddingRight: "12px",
                        paddingLeft: "12px",
                      }}
                    >
                      {Math.round(item?.totalSponsorOnHand * 1000) / 1000 ||
                        "0"}
                    </div>
                    <div
                      style={{
                        // backgroundColor: "#A1AFCC",
                        color: "#1B4489",
                        paddingTop: "2rem",
                        paddingBottom: "2.5rem",
                        paddingRight: "12px",
                        paddingLeft: "12px",
                      }}
                    >
                      {Math.round(item?.totalCMOOnHand * 1000) / 1000 || "0"}
                    </div>
                  </TableCell>
                  <TableCell
                    className={classes.cellStyle}
                    align="right"
                  ></TableCell>
                  <TableCell
                    className={classes.cellStyle}
                    align="right"
                  ></TableCell>
                  <TableCell
                    style={{ padding: "0px" }}
                    className={classes.cellStyle}
                    align="right"
                  >
                    <div
                      style={{
                        // backgroundColor: "#cbb1c3",
                        color: "#BE2BBB",
                        paddingTop: "2.5rem",
                        paddingBottom: "2rem",
                        paddingRight: "12px",
                        paddingLeft: "12px",
                      }}
                    >
                      {Math.round(item?.totalSponsorCommitted * 1000) / 1000 ||
                        "0"}
                    </div>
                    <div
                      style={{
                        // backgroundColor: "#A1AFCC",
                        color: "#1B4489",
                        paddingTop: "2rem",
                        paddingBottom: "2.5rem",
                        paddingRight: "12px",
                        paddingLeft: "12px",
                      }}
                    >
                      {Math.round(item?.totalCMOCommitted * 1000) / 1000 || "0"}
                    </div>
                  </TableCell>
                  <TableCell
                    className={classes.cellStyle}
                    align="right"
                  ></TableCell>
                  <TableCell
                    className={classes.cellStyle}
                    align="right"
                  ></TableCell>
                  <TableCell className={classes.cellStyle}>
                    {item.inventoryUOM}
                  </TableCell>
                  <TableCell
                    className={classes.reasonCode}
                    align="right"
                  ></TableCell>
                </TableRow>
                <TableCell colSpan={11} style={{ padding: 0 }}>
                  <Collapse in={openRows[item.materialInfo]}>
                    {item.lotNumberDetailsList.map((lot, index) => (
                      <Box style={{ width: "100%" }}
                        //  key={lot.sponsorLotNumber}
                        key={`${lot.sponsorLotNumber}-${index}`}
                      >
                        <Table className={classes.table} size="small">
                          <TableBody>
                            <TableRow hover className={classes.collapsedRow}>
                              <TableCell>
                                <IconButton
                                  size="small"
                                  style={{
                                    visibility: "hidden",
                                    pointerEvents: "none",
                                  }}
                                >
                                  <KeyboardArrowUpIcon />
                                </IconButton>
                              </TableCell>
                              <TableCell className={classes.cellStyle}>
                                {item.materialInfo}
                              </TableCell>

                              <TableCell
                                style={{ padding: "0px" }}
                                className={classes.cellStyle}
                              >
                                <div style={{ display: "flex", alignItems: "center", flexDirection: "row" }}>
                                  <div>
                                    <div
                                      style={{
                                        // backgroundColor: "#cbb1c3",
                                        color: "#BE2BBB",
                                        paddingTop: "1rem",
                                        paddingBottom: "0.5rem",
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        paddingRight: "12px",
                                        paddingLeft: "12px",
                                      }}
                                    >
                                      {lot?.sponsorLotNumber || "NA"}
                                    </div>
                                    <div
                                      style={{
                                        // backgroundColor: "#A1AFCC",
                                        color: "#1B4489",
                                        paddingTop: "0.5rem",
                                        paddingBottom: "1rem",
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        paddingRight: "12px",
                                        paddingLeft: "12px",
                                      }}
                                    >
                                      {lot?.cmoLotNumber || "NA"}
                                    </div>
                                  </div>
                                  {lot?.batchExpired === true ? (
                                    <FlagIcon
                                      style={{
                                        color: "red",
                                        fontSize: 28, // Small size
                                        stroke: "black", // Outline color
                                        strokeWidth: 1.3, // Adjust for thinness
                                      }}
                                    />
                                  ) : lot?.batchNearExpiry === true ? (
                                    <FlagIcon
                                      style={{
                                        color: "yellow",
                                        fontSize: 28, // Small size
                                        stroke: "black", // Outline color
                                        strokeWidth: 1.3, // Adjust for thinness
                                      }}
                                    />
                                  ) : null}
                                </div>
                              </TableCell>
                              <TableCell
                                style={{ padding: "0px" }}
                                className={classes.cellStyle}
                                align="right"
                              >
                                <div
                                  style={{
                                    // backgroundColor: "#cbb1c3",
                                    color: "#BE2BBB",
                                    paddingTop: "1rem",
                                    paddingBottom: "0.5rem",
                                    paddingRight: "12px",
                                    paddingLeft: "12px",
                                  }}
                                >
                                  {Math.round(
                                    lot?.sponsorOnHandAvailableQuantity * 1000
                                  ) / 1000 || "0"}
                                </div>
                                <div
                                  style={{
                                    // backgroundColor: "#A1AFCC",
                                    color: "#1B4489",
                                    paddingTop: "0.5rem",
                                    paddingBottom: "1rem",
                                    paddingRight: "12px",
                                    paddingLeft: "12px",
                                  }}
                                >
                                  {Math.round(
                                    lot?.cmoOnHandAvailableQuantity * 1000
                                  ) / 1000 || "0"}
                                </div>
                              </TableCell>
                              <TableCell
                                className={classes.cellStyle}
                                align="right"
                                style={{
                                  fontWeight:
                                    lot?.onHandQuantityDifference > 0
                                      ? "bold"
                                      : "normal",
                                }}
                              >
                                {Math.round(
                                  lot?.onHandQuantityDifference * 1000
                                ) / 1000 || "0"}
                              </TableCell>
                              <TableCell
                                className={classes.cellStyle}
                                align="right"
                              >
                                {lot.onHandQtyDifferencePercentage}
                              </TableCell>
                              <TableCell
                                style={{ padding: "0px" }}
                                className={classes.cellStyle}
                                align="right"
                              >
                                <div
                                  style={{
                                    // backgroundColor: "#cbb1c3",
                                    color: "#BE2BBB",
                                    paddingTop: "1rem",
                                    paddingBottom: "0.5rem",
                                    paddingRight: "12px",
                                    paddingLeft: "12px",
                                  }}
                                >
                                  {Math.round(
                                    lot?.sponsorCommittedQuantity * 1000
                                  ) / 1000 || "0"}
                                </div>
                                <div
                                  style={{
                                    // backgroundColor: "#A1AFCC",
                                    color: "#1B4489",
                                    paddingTop: "0.5rem",
                                    paddingBottom: "1rem",
                                    paddingRight: "12px",
                                    paddingLeft: "12px",
                                  }}
                                >
                                  {Math.round(
                                    lot?.cmoCommittedQuantity * 1000
                                  ) / 1000 || "0"}
                                </div>
                              </TableCell>
                              <TableCell
                                className={classes.cellStyle}
                                align="right"
                                style={{
                                  fontWeight:
                                    lot?.committedQuantityDifference > 0
                                      ? "bold"
                                      : "normal",
                                }}
                              >
                                {Math.round(
                                  lot.committedQuantityDifference * 1000
                                ) / 1000}
                              </TableCell>
                              <TableCell
                                className={classes.cellStyle}
                                align="right"
                              >
                                {lot.committedQtyDifferencePercentage}
                              </TableCell>
                              <TableCell className={classes.cellStyle}>
                                {item.inventoryUOM}
                              </TableCell>
                              <TableCell
                                className={classes.reasonCode}
                                // align="center"
                                style={{
                                  // backgroundColor: "green",
                                  padding: 0,
                                }}
                              >
                                {/* {lot.reasonForDifference} */}
                                {lot.reasonForDifference
                                  ? lot.reasonForDifference
                                  : reasonDropDown(
                                    lot.sponsorLotNumber,
                                    lot.reasonForDifference
                                  )}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Box>
                    ))}
                  </Collapse>
                </TableCell>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <Backdrop
        className={classes.backdrop}
        open={loading}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box className={classes.container}>
          <Typography variant="body1">Legend:</Typography>
          <Box className={classes.legendItem}>
            <Box className={`${classes.colorBox} ${classes.bmsColor}`} />
            <Typography variant="body2">Sponsor Values</Typography>
          </Box>
          <Box className={classes.legendItem}>
            <Box className={`${classes.colorBox} ${classes.cmoColor}`} />
            <Typography variant="body2">CMO Values</Typography>
          </Box>
        </Box>
        <Box className={classes.buttonContainer}>
          <Button
            className={classes.btnSave}
            onClick={() => handleSave()}
            variant="contained"
            size="small"
            disabled={!hasChanges || batchLoading}
            endIcon={<KeyboardArrowRightIcon>send</KeyboardArrowRightIcon>}
          >
            Save Changes
          </Button>
        </Box>
        <Box width="300px">
          <ChatBox
            vendorMosymphonyID={apiData?.vendorMosymphonyID}
          />
        </Box>
      </div>
    </Box>
  );
}
